import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Link from '@src/components/link';
import useAnchorScrollSpy from '@src/utils/hooks/use-anchor-scroll-spy';
import ComponentStore from './store';
const styles = require('./index.less');

// 顶部/侧栏锚点导航目标 = CMS 正文内写死的小节 id（顺序与导航项一致）
// TODO: 锚点 id 依赖 CMS 正文内的 id，须与本届真实 CMS 内容一致（占位期可能不匹配）
const ANCHORS = ['金币红包', '特享好礼', '抖音视频', '发财小鸡', '庆典蛋糕', '珍馐雅味'];

// 背景与公共组件导航已上提到 list 页统一渲染，内页只负责自身锚点导航 + CMS 正文
const WelfareCarnival = ({ store, className }) => {
  store.use();
  const { activeAnchor, showSidebar, scrollToAnchor, scrollToTop } = useAnchorScrollSpy(ANCHORS);

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.group1} data-name={'福利狂欢内页'}>
        <div className={styles.group2} data-name={'内容'}>
          <div className={cx(styles.group3, styles.fadeInDown)} data-name={'cms主体内容区'}>
            {/* 单篇 CMS HTML，内含写死 id 锚点小节，由 store 归一化输出 contentHtml */}
            <div className={styles.layer2} data-name={'cms内容'} dangerouslySetInnerHTML={{ __html: store.contentHtml }} />
          </div>
          <div className={cx(styles.group4, styles.fadeInUp)} data-name={'顶部导航条'}>
            <div className={styles.layer3} data-name={'顶部导航标题'} />
            <div className={styles.group5} data-name={'顶部导航按钮'}>
              <div className={styles.layer4} data-name={'按钮组背景'} />
              <div className={styles.group6} data-name={'按钮组list'}>
                <Link
                  className={cx(styles.group7, { [styles.active]: activeAnchor === '金币红包' })}
                  data-name={'金币红包'}
                  onClick={() => scrollToAnchor('金币红包')}
                >
                  <div className={styles.layer5} data-name={'金币红包-常态'} />
                  <div className={styles.layer6} data-name={'金币红包-选中/悬停'} />
                </Link>
                <Link
                  className={cx(styles.group8, { [styles.active]: activeAnchor === '特享好礼' })}
                  data-name={'特享好礼'}
                  onClick={() => scrollToAnchor('特享好礼')}
                >
                  <div className={styles.layer7} data-name={'特享好礼-常态'} />
                  <div className={styles.layer8} data-name={'特享好礼-选中/悬停'} />
                </Link>
                <Link
                  className={cx(styles.group9, { [styles.active]: activeAnchor === '抖音视频' })}
                  data-name={'抖音视频'}
                  onClick={() => scrollToAnchor('抖音视频')}
                >
                  <div className={styles.layer9} data-name={'抖音视频-常态'} />
                  <div className={styles.layer10} data-name={'抖音视频-选中/悬停'} />
                </Link>
                <Link
                  className={cx(styles.group10, { [styles.active]: activeAnchor === '发财小鸡' })}
                  data-name={'发财小鸡'}
                  onClick={() => scrollToAnchor('发财小鸡')}
                >
                  <div className={styles.layer11} data-name={'发财小鸡-常态'} />
                  <div className={styles.layer12} data-name={'发财小鸡-选中/悬停'} />
                </Link>
                <Link
                  className={cx(styles.group11, { [styles.active]: activeAnchor === '庆典蛋糕' })}
                  data-name={'庆典蛋糕'}
                  onClick={() => scrollToAnchor('庆典蛋糕')}
                >
                  <div className={styles.layer13} data-name={'庆典蛋糕-常态'} />
                  <div className={styles.layer14} data-name={'庆典蛋糕-选中/悬停'} />
                </Link>
                <Link
                  className={cx(styles.group12, { [styles.active]: activeAnchor === '珍馐雅味' })}
                  data-name={'珍馐雅味'}
                  onClick={() => scrollToAnchor('珍馐雅味')}
                >
                  <div className={styles.layer15} data-name={'珍馐雅味-常态'} />
                  <div className={styles.layer16} data-name={'珍馐雅味-选中/悬停'} />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className={cx(styles.group13, { [styles.visible]: showSidebar })} data-name={'右侧侧栏导航'}>
          <div className={styles.layer17} data-name={'侧栏背景'} />
          <div className={styles.group14} data-name={'侧栏按钮组'}>
            <Link
              className={cx(styles.group15, { [styles.active]: activeAnchor === '金币红包' })}
              data-name={'金币红包'}
              onClick={() => scrollToAnchor('金币红包')}
            >
              <div className={styles.layer18} data-name={'金币红包-常态'} />
              <div className={styles.layer19} data-name={'金币红包-选中/悬停'} />
            </Link>
            <Link
              className={cx(styles.group16, { [styles.active]: activeAnchor === '特享好礼' })}
              data-name={'特享好礼'}
              onClick={() => scrollToAnchor('特享好礼')}
            >
              <div className={styles.layer20} data-name={'特享好礼-常态'} />
              <div className={styles.layer21} data-name={'特享好礼-选中/悬停'} />
            </Link>
            <Link
              className={cx(styles.group17, { [styles.active]: activeAnchor === '抖音视频' })}
              data-name={'抖音视频'}
              onClick={() => scrollToAnchor('抖音视频')}
            >
              <div className={styles.layer22} data-name={'抖音视频-常态'} />
              <div className={styles.layer23} data-name={'抖音视频-选中/悬停'} />
            </Link>
            <Link
              className={cx(styles.group18, { [styles.active]: activeAnchor === '发财小鸡' })}
              data-name={'发财小鸡'}
              onClick={() => scrollToAnchor('发财小鸡')}
            >
              <div className={styles.layer24} data-name={'发财小鸡-常态'} />
              <div className={styles.layer25} data-name={'发财小鸡-选中/悬停'} />
            </Link>
            <Link
              className={cx(styles.group19, { [styles.active]: activeAnchor === '庆典蛋糕' })}
              data-name={'庆典蛋糕'}
              onClick={() => scrollToAnchor('庆典蛋糕')}
            >
              <div className={styles.layer26} data-name={'庆典蛋糕-常态'} />
              <div className={styles.layer27} data-name={'庆典蛋糕-选中/悬停'} />
            </Link>
            <Link
              className={cx(styles.group20, { [styles.active]: activeAnchor === '珍馐雅味' })}
              data-name={'珍馐雅味'}
              onClick={() => scrollToAnchor('珍馐雅味')}
            >
              <div className={styles.layer28} data-name={'珍馐雅味-常态'} />
              <div className={styles.layer29} data-name={'珍馐雅味-选中/悬停'} />
            </Link>
            <Link className={styles.group21} data-name={'返回顶部'} onClick={scrollToTop}>
              <div className={styles.layer30} data-name={'返回顶部-常态'} />
              <div className={styles.layer31} data-name={'返回顶部-选中/悬停'} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default wrapStore(WelfareCarnival, ComponentStore);
